const RESULT_LABELS = {
  match: 'Match',
  'wrong-amount': 'Wrong amount',
  missing: 'Missing',
  unexpected: 'Not expected',
};

const cellStyle = {
  padding: '0.4rem 0.75rem',
  fontSize: '0.85rem',
  whiteSpace: 'nowrap',
};

const formatAmount = (amount) =>
  amount == null
    ? '-'
    : amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

/**
 * Pass/fail diff of a guidance test's payables against the payables the
 * operator expected (the preview's `expectedCheck`).
 */
const ExpectedPayablesCheck = ({ check }) => {
  const unexpected = check.rows.filter((r) => r.result === 'unexpected').length;
  const summary = [
    `${check.matched} of ${check.expectedCount} expected payables match`,
    unexpected > 0 && `${unexpected} not expected`,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <section
      aria-label="Expected payables check"
      style={{
        border: `1px solid var(${check.pass ? '--green' : '--red'})`,
        borderRadius: '0.35rem',
        padding: '0.75rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
      }}
    >
      <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--black)' }}>
        <strong style={{ color: `var(${check.pass ? '--green' : '--red'})` }}>
          {check.pass ? 'Pass' : 'Fail'}
        </strong>
        {` - ${summary}.`}
      </p>
      <div className="table-wrapper" style={{ height: 'auto', width: '100%' }}>
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={cellStyle}>Result</th>
              <th style={cellStyle}>Expected</th>
              <th style={cellStyle}>Amount</th>
              <th style={cellStyle}>Produced</th>
              <th style={cellStyle}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {check.rows.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...cellStyle,
                    color:
                      row.result === 'match' ? 'var(--green)' : 'var(--red)',
                  }}
                >
                  {RESULT_LABELS[row.result]}
                </td>
                <td style={cellStyle}>{row.account ?? '-'}</td>
                <td style={cellStyle}>{formatAmount(row.expectedAmount)}</td>
                <td style={cellStyle}>{row.producedAccount ?? '-'}</td>
                <td style={cellStyle}>{formatAmount(row.producedAmount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ExpectedPayablesCheck;
